import React, { Component } from "react";
// import children
import "../css/variant_table.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as StudyActions from "../../../../../../../reducers/study_actions";
import ChromosomeChart from "../../chromosome-chart/ChromosomeChart";
import { withTranslation } from "react-i18next";
import LeftPanel from "../../../../variant-tabs/ExternalResources";
import { processVariantData } from "../variant-helpers";
import SNV_Table from "./SNV_Table";
import { getAnalysisAnnotations, getStudy } from "../getAnnotations";
import ParticipantTable from "../../../../../../../../../components/tables/ParticipantTable/ParticipantTable";
import { prepareVariantsTable } from "./variant_finder";
import AnalysesTabs from "../../../analyses-tabs/AnalysesTabs";
import QueryTabs from "../../../QueryTabs";
import MappedText from "../../../../../../../../instand/reports/create-report/shared-components/mapText";


// MUI 5 Imports
import Box from "@mui/material/Box";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";

// Static Variables
import { STATIC_VARIABLES } from "../../../../../../../../../config-files/const_variables";
import { getCurrentQuery } from "../../query-applied-filters/query_difference";

// Custom Components
import AccordionInfo from "../component/AccordionInfo";
import CustomCNVTable from "../../../../../../../../../components/tables/customVariantTable/CustomTableForCNVs";

// CNV Configuration
import { additional_info_1, additional_info_2 } from "./cnv_config/additional_info";
import CNV_DATA_HEADER_FULL_v2 from "./cnv_config/headers/data_header_full_v2";
import CNV_DATA_HEADER_SPLIT_v2 from "./cnv_config/headers/data_header_split_v2";

// GPAP General Actions
import * as GPAP_General_Actions from "../actions";

// New Toolbar Component
import ToolBar_New from "../../toolbar/toolbar-new/ToolBar_New";
import {Alert} from "@mui/material";

class Variant_Table extends Component{

    constructor(props) {
        super(props);
        this.state = {
            selected: null,
            selectedRows: [],
            viewMode: true,
            tableType: true,
            selectedVariant: [],
            selectedParticipants: [],
            selectedExperiments: [],
            from:0,
            cnvNumber: 0,
            snackMessage: false,
            cnvSnackText: null,
            selectedGene: "",
            loadingCNV: false,
            participantScopedCNV: false
    };


        // config

        this.getTableDataContent = this.getTableDataContent.bind(this);
        this.setViewMode = this.setViewMode.bind(this);
        this.getTable = this.getTable.bind(this);
        this.annotate_variants = this.annotate_variants.bind(this);
        this.collectVariants = this.collectVariants.bind(this);
        this.getParticipantTable = this.getParticipantTable.bind(this);
        this.getCNVTable = this.getCNVTable.bind(this);
        this.setTableType = this.setTableType.bind(this);
        this.selectParticipant = this.selectParticipant.bind(this);
        this.selectedExperiments = this.selectedExperiments.bind(this);
        this.passGenes = this.passGenes.bind(this);
        this.getCNVNumber = this.getCNVNumber.bind(this);
        this.setSelectedCNV = this.setSelectedCNV.bind(this);
        this.handleSnackClose = this.handleSnackClose.bind(this);
        this.setLoadingCNVData = this.setLoadingCNVData.bind(this);
    }


    collectVariants(){
        let {studySettings, studyBucket} = this.props;
        let study = getStudy(studySettings, studyBucket);

        if(study!== undefined && study.study!== undefined){
            this.setState({
                tagged_variants: study.study.tagged_variants
            })
        }

    }

    componentDidMount() {

        this.collectVariants()

    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.studySettings?.current_query !== prevProps.studySettings?.current_query) {
            this.setState({
                selectedGene: "All",
                selectedParticipants: [],
                participantScopedCNV: false,
            });
        }

        if(this.props.selected_table_rows !== prevProps.selected_table_rows){

            console.log("Variant Table selected", this.props.selected_table_rows)
            let selectedVariants = this.props.selected_table_rows?.[0]?.data_row;

            let selectedExperiments = selectedVariants?.[0]?.samples_germline?.map(s => s.sample) || [];

            this.setState({
                selectedVariants: selectedVariants,
                selectedExperiments: selectedExperiments
            });

        }




    }

    handleGeneSelected = (gene) => {
        this.setState({ selectedGene: gene, participantScopedCNV: false });
        this.props.runSearchAcrossQuery(gene);
      };

    /** Cohort CNV aggregation failure — same Snackbar as CNV table errors. */
    handleCnvQueryError = (detail) => {
        if (!detail) return;
        this.setState({
            snackMessage: true,
            cnvSnackText: `CNV query: ${detail}`
        });
    };

    setLoadingCNVData(bool){
        this.setState({
            loadingCNV:bool
        })
    }

    getTableDataContent(){

        let { variants } =this.props;
        const data = prepareVariantsTable(variants, this.state.viewMode);
        return {
            data: data,
            variants: data
        }

    }

    annotate_variants = (type, extra, operation_type) => {

        let { study_actions, studySettings, selected_table_rows} = this.props;

        let selected_germline = selected_table_rows.find(s => s.data_type === "SNV_Germline");
        let selected_somatic = selected_table_rows.find(s => s.data_type === "SNV_Somatic");

        let selected_rows = [];
        if(selected_germline && selected_germline.data_row.length>0) {
            selected_rows= selected_germline.data_row;
        }
        else {
            selected_rows= selected_somatic.data_row;
        }

        if(selected_rows)
        {
            study_actions.annotate_variants(
                {
                    query_id: studySettings.current_query,
                    analysis_id: studySettings.current_analysis,
                    study_id: studySettings.id,
                    variants: selected_rows,
                    label: extra,
                    type: type,
                    operation_type: operation_type
                }
            );
        }

        this.collectVariants()

    };




    setViewMode(bool){

        this.setState({viewMode:bool})  //true => variant table, false => Functional Mode


    }

    selectParticipant = (participants, fromParticipantTable, type, runQuery, queryMeta) => {

        this.setState({
            selectedParticipants: participants,
            participantScopedCNV: fromParticipantTable && runQuery
        });

        if (fromParticipantTable && !runQuery) {
            this.props.clearVariantsOnly?.();
            return;
        }

        let selected = participants;
        let experiment_ids = [];
        if (participants !== "ALL_SAMPLES") {

            if(type === "participants"){
                const participantRows = Array.isArray(this.props.participants?.participants)
                    ? this.props.participants.participants
                    : [];
                experiment_ids = participantRows
                    .filter((p) => selected.includes(p.report_id))
                    .flatMap((p) => String(p.ExperimentID || "")
                        .split(",")
                        .map((id) => id.trim())
                        .filter(Boolean));
                experiment_ids = [...new Set(experiment_ids)];
                if (experiment_ids.length === 0 && Array.isArray(this.props.participants?.map_by_exp)) {
                    experiment_ids = this.props.participants.map_by_exp
                        .filter((exp) => selected.includes(exp.Participant_ID))
                        .map((exp) => exp.ExperimentID);
                }
            }
            else{
                experiment_ids = selected;
            }

        } else {
            experiment_ids = participants;
        }

        const geneView = this.props.selectedGeneForVariantView;
        let selectedGeneQuery;
        if (geneView === "All" || geneView == null || geneView === "") {
            selectedGeneQuery = [];
        } else if (Array.isArray(geneView)) {
            selectedGeneQuery = geneView;
        } else {
            selectedGeneQuery = geneView;
        }
        this.props.runSearchAcrossQuery(selectedGeneQuery, experiment_ids, fromParticipantTable, queryMeta);
    };

    selectedExperiments = (experiments, genes) => {


        this.setState({
            selectedExperiments:  experiments,
            participantScopedCNV: false
        });

        // shoot query with genes;

        this.props.runSearchAcrossQuery(genes, experiments)



    };

    passGenes = (genes) => {


        this.setState({
            selectedGenes:  genes,
            participantScopedCNV: false
        });

        this.props.runSearchAcrossQuery(genes, this.state.selectedExperiments)

    };

    getCNVNumber = (summary) =>{
        const { full_tot, split_tot, tot, errorMessage } = summary || {};
        const count = (typeof tot === "number" && tot >= 0) ? tot : 0;
        const failed = tot === -1;
        this.setState({
            cnvNumber: count,
            cnvRegions: full_tot,
            snackMessage: failed,
            cnvSnackText: failed
                ? (errorMessage ? `CNV query: ${errorMessage}` : "CNV query: CNV data could not be loaded")
                : null
        });
        this.props.getCNVTotal(summary);
    }

    handleSnackClose = () => {

        this.setState({ snackMessage: false, cnvSnackText: null })
    }


    setSelectedCNV = (cnv_row) => {


        let {gpap_general_actions} = this.props;


        if(cnv_row){

            gpap_general_actions.setSelectedTableRows({
                data_row : [cnv_row],
                data_type: "CNV",
            })

        }



    }

    getCNVTable(){

        const { i18n } = this.props;
        let url = window.config.apis_configuration.api_nextgpap_server_elastic + "/api/cnvs";
        const appendixKey = (this.props.genes_state && this.props.genes_state.length > 0)
        ? 'Genes filter applied'
        : 'no filters applied';
        const appendixTitle = `- ${i18n.t(appendixKey, { ns: 'translation' })}`;
        
        // headers to show
        let cnv_full_data_header = CNV_DATA_HEADER_FULL_v2;
        let cnv_split_data_header = CNV_DATA_HEADER_SPLIT_v2;

        const isSNVSelected = this.props.selected_table_rows.some(s =>
             (s.data_type === "SNV_Somatic" || s.data_type === "SNV_Germline") && s.data_row.length > 0
         );

        // Cohort analysis: use the cohort's experiment IDs so the CNV call does not depend on SNV hits.
        // sampleList can later shrink to experiments that have SNV rows, which would otherwise trigger a second CNV query.
        // "Show Participant Variants" is intentionally scoped to selected participant experiments, so use sampleList there.
        const participantExperimentList = Array.isArray(this.props.sampleList) ? this.props.sampleList : [];
        const cohortExperimentList = Array.isArray(this.props.cohortExperimentIds) ? this.props.cohortExperimentIds : [];
        const useParticipantScopedExperiments = this.state.participantScopedCNV && participantExperimentList.length > 0;
        const experimentList = (this.props.type === "search_across")
            ? (useParticipantScopedExperiments
                ? participantExperimentList
                : (cohortExperimentList.length > 0 ? cohortExperimentList : participantExperimentList))
            : (cohortExperimentList.length > 0
                ? cohortExperimentList
                : this.props.experiment);
        const sv = this.props.selectedGeneForVariantView;
        const noSpecificGeneSelected = sv === "All" || sv == null || (Array.isArray(sv) && sv.length === 0);
        const clearedByParticipantSelection = Boolean(this.props.variantTablesClearedByParticipantSelection);
        // When user just selected a different participant: clear CNV table and show 0 without changing gene (Participant table counts stay stable).
        const isSearchAcross = this.props.type === "search_across";
        // Fetch the CNV table as soon as experiments are available, for both the cohort/search-across
        // and the normal case. When "All" genes is selected, use the query's gene filter.
        const shouldFetchCNV = experimentList.length > 0 && !clearedByParticipantSelection;
        // Cohort: use the gene clicked in the gene table. Normal case: use the query's gene filter.
        const filteredGenes = Array.isArray(this.props.genes_state) ? this.props.genes_state : [];
        let genesForCNV;
        if (Array.isArray(sv) && sv.length > 0) {
            genesForCNV = sv;
        } else if (!noSpecificGeneSelected && shouldFetchCNV) {
            genesForCNV = [sv];
        } else if (filteredGenes.length > 0) {
            genesForCNV = filteredGenes;
        } else {
            genesForCNV = [];
        }
        const cnvDisplayTotal = (clearedByParticipantSelection || (isSearchAcross && !shouldFetchCNV))
            ? 0
            : (this.state.cnvNumber ?? 0);

        return <Box p={1} style={{float: "left", width: "100%"}}>
            <Accordion defaultExpanded={false}>
                <AccordionInfo
                               loading={(this.state.loadingCNV)}
                               title={ "CNVs and SVs"}
                               total={cnvDisplayTotal}
                               appendixTitle = {appendixTitle}
                               tooltipTitle= {<MappedText text="The displayed number is the total sum of events in the FULL and SPLIT results."/>}
                />
                <AccordionDetails>
                <Box style={{ overflow: "auto", overflowY: "hidden", maxHeight: "100%" }}>
                    <CustomCNVTable
                      url={url}
                      method={"POST"}
                      token={this.props.token}
                      locationData="items"
                      dataType={"CNV"}
                      experiment={experimentList}
                      genes={genesForCNV}
                      shouldFetchCNV={shouldFetchCNV}
                      isSearchAcross={isSearchAcross}
                      freqInt={this.props.freqInt_state}
                      clinvar={this.props.clinvar_state}
                      acmg={this.props.acmg_state}
                      getTotal = {this.getCNVNumber}
                      setSelected = {this.setSelectedCNV}
                      configFilter={[
                        {
                            full: {
                            dataSearch: "Annotation_mode",
                            keyFilter: "full",
                          },
                        },
                        {
                          split: {
                            dataSearch: "Annotation_mode",
                            keyFilter: "split",
                          },
                        },
                      ]}
                      dataHeader={cnv_full_data_header}
                      compactColumns = {[
                    {
                        referenceTable: "ACMG Classific.",
                        nameColumn: "AnnotSV reported pathogenic",
                        tooltip: "Phenotype of the pathogenic genomic regions completely overlapped with the SV. Source is displayed in the dbVarNR (dbVar), ClinVar (CLN), ClinGen (TS3).",
                        dataSearch: "SV_type",
                        position: "right",
                        rowSelect: [
                    {
                        replaceWith: "P_gain_phen",
                        dataSearch: "P_gain_phen",
                        value: "DUP",
                    },
                    {
                        replaceWith: "P_loss_phen",
                        dataSearch: "P_loss_phen",
                        value: "DEL",
                    },
                    {
                        replaceWith: "P_ins_phen",
                        dataSearch: "P_ins_phen",
                        value: "INS",
                    },
                        ],
                    },
                    {
                        referenceTable: "Internal Freq.",
                        nameColumn: "AnnotSV population AFMax",
                        tooltip: "Maximum allele frequency of the reported benign genomic regions completely overlapped with the SV. Source is displayed in the tooltip: gnomAD, ClinVar (CLN), ClinGen (TS40), DGV (dgv, nsv or esv), DDD, 1000 genomes (1000g), Ira M. Hall’s lab (IMH), Children’s Mercy Research Institute (CMRI). This filter applies values equal to or less than the specified threshold.",
                        dataSearch: "SV_type",
                        position: "left",
                        defaultValue: 0,
                        filter: "numeric",
                        filterType: { type: "numeric_population" },
                        type: "number",
                        rowSelect: [
                    {
                        replaceWith: "B_gain_AFmax",
                        dataSearch: "B_gain_AFmax",
                        value: "DUP",
                    },
                    {
                        replaceWith: "B_loss_AFmax",
                        dataSearch: "B_loss_AFmax",
                        value: "DEL",
                    },
                    {
                        replaceWith: "B_ins_AFmax",
                        dataSearch: "B_ins_AFmax",
                        value: "INS",
                    },
                        ],
                    },
                    ]}
                      compactColumnsSplit= {[
                    {
                        referenceTable: "OMIM",
                        nameColumn: "AnnotSV reported pathogenic",
                        tooltip: "Phenotype of the pathogenic genomic regions completely overlapped with the SV. Source is displayed in the dbVarNR (dbVar), ClinVar (CLN), ClinGen (TS3).",
                        dataSearch: "SV_type",
                        position: "right",
                        rowSelect: [
                    {
                        replaceWith: "P_gain_phen",
                        dataSearch: "P_gain_phen",
                        value: "DUP",
                    },
                    {
                        replaceWith: "P_loss_phen",
                        dataSearch: "P_loss_phen",
                        value: "DEL",
                    },
                    {
                        replaceWith: "P_ins_phen",
                        dataSearch: "P_ins_phen",
                        value: "INS",
                    },
                        ],
                    },
                    {
                        referenceTable: "Internal Freq.",
                        nameColumn: "AnnotSV population AFMax",
                        dataSearch: "SV_type",
                        position: "left",
                        defaultValue: 0,
                        filter: "numeric",
                        filterType: { type: "numeric_population" },
                        type: "number",
                        rowSelect: [
                    {
                        replaceWith: "B_gain_AFmax",
                        dataSearch: "B_gain_AFmax",
                        value: "DUP",
                    },
                    {
                        replaceWith: "B_loss_AFmax",
                        dataSearch: "B_loss_AFmax",
                        value: "DEL",
                    },
                    {
                        replaceWith: "B_ins_AFmax",
                        dataSearch: "B_ins_AFmax",
                        value: "INS",
                    },
                        ],
                    },
                    ]}
                      tooltipCompact={ [
                    {
                        referenceTable: "AnnotSV reported pathogenic",
                        dataSearch: "SV_type",
                        rowSelect: [
                    {
                        replaceWith: "P_loss_source",
                        dataSearch: "P_loss_source",
                        value: "DEL",
                    },
                        ],
                    },
                    {
                        referenceTable: "AnnotSV reported pathogenic",
                        dataSearch: "SV_type",
                        rowSelect: [
                    {
                        replaceWith: "P_gain_source",
                        dataSearch: "P_gain_source",
                        value: "DUP",
                    },
                        ],
                    },
                    {
                        referenceTable: "AnnotSV reported pathogenic",
                        dataSearch: "SV_type",
                        rowSelect: [
                    {
                        replaceWith: "P_ins_source",
                        dataSearch: "P_ins_source",
                        value: "INS",
                    },
                        ],
                    },
                    {
                        referenceTable: "AnnotSV population AFMax",
                        dataSearch: "SV_type",
                        rowSelect: [
                    {
                        replaceWith: "B_loss_source",
                        dataSearch: "B_loss_source",
                        value: "DEL",
                    },
                        ],
                    },
                    {
                        referenceTable: "AnnotSV population AFMax",
                        dataSearch: "SV_type",
                        rowSelect: [
                    {
                        replaceWith: "B_gain_source",
                        dataSearch: "B_gain_source",
                        value: "DUP",
                    },
                        ],
                    },
                    {
                        referenceTable: "AnnotSV population AFMax",
                        dataSearch: "SV_type",
                        rowSelect: [
                    {
                        replaceWith: "B_ins_source",
                        dataSearch: "B_ins_source",
                        value: "INS",
                    },
                        ],
                    },
                    ]}
                      tooltipCompactSplit = {[
                    {
                        referenceTable: "AnnotSV reported pathogenic",
                        dataSearch: "SV_type",
                        rowSelect: [
                    {
                        replaceWith: "P_loss_source",
                        dataSearch: "P_loss_source",
                        value: "DEL",
                    },
                        ],
                    },
                    {
                        referenceTable: "AnnotSV reported pathogenic",
                        dataSearch: "SV_type",
                        rowSelect: [
                    {
                        replaceWith: "P_gain_source",
                        dataSearch: "P_gain_source",
                        value: "DUP",
                    },
                        ],
                    },
                    {
                        referenceTable: "AnnotSV reported pathogenic",
                        dataSearch: "SV_type",
                        rowSelect: [
                    {
                        replaceWith: "P_ins_source",
                        dataSearch: "P_ins_source",
                        value: "INS",
                    },
                        ],
                    },
                    {
                        referenceTable: "AnnotSV population AFMax",
                        dataSearch: "SV_type",
                        rowSelect: [
                    {
                        replaceWith: "B_loss_source",
                        dataSearch: "B_loss_source",
                        value: "DEL",
                    },
                        ],
                    },
                    {
                        referenceTable: "AnnotSV population AFMax",
                        dataSearch: "SV_type",
                        rowSelect: [
                    {
                        replaceWith: "B_gain_source",
                        dataSearch: "B_gain_source",
                        value: "DUP",
                    },
                        ],
                    },
                    {
                        referenceTable: "AnnotSV population AFMax",
                        dataSearch: "SV_type",
                        rowSelect: [
                    {
                        replaceWith: "B_ins_source",
                        dataSearch: "B_ins_source",
                        value: "INS",
                    },
                        ],
                    },

                    ]}
                      chipFull ={[
                    {
                        referenceColumn: "ACMG Classific.",
                        cells: [
                    {
                        data: "Likely pathogenic",
                        color: "#FD7645",
                        textColor: "white",
                    },
                    {
                        data: "Benign",
                        color: "#31A354",
                        textColor: "white",
                    },
                    {
                        data: "Uncertain significance",
                        color: "grey",
                        textColor: "white",
                    },
                    {
                        data: "Pathogenic",
                        color: "#DD4434",
                        textColor: "white",
                    },
                        ],
                    },
                    ]}
                      nestedInfo={additional_info_1}
                      split={cnv_split_data_header}
                      nestedInfoB={additional_info_2}
                      customFeatures = {[
                            { switchFS: true },
                            ]}
                      buttons={[
                        {
                          nameButton: "Population",
                          type: "popover",
                          template: "Population",
                          data: ["B_gain_AFmax", "B_loss_AFmax", "B_ins_AFmax", "B_inv_AFmax"],
                        },
                      ]}
                      queryID = {this.props.studySettings.current_query}
                      setLoading = {this.setLoadingCNVData}
                      loadingData = {this.state.loadingCNV}
                      // how can we make this more generic?
                      getAllTaggedVariants={this.props.getAllTaggedVariants}
                      all_tagged_variants={this.props.all_tagged_variants}
                      isSNVSelected = {isSNVSelected}
                    />
                    </Box>
                </AccordionDetails>

            </Accordion>
        </Box>
    }


    getParticipantTable(){

        console.log("render participant table");
        let data_table = {...this.props.participants};

       /* // selected experiments
        if(this.state.selectedExperiments.length!==0){

            // take the last entered
            let selectedExperiments = this.state.selectedExperiments; //e.g ["EOOOO1", "EOOOO4"]
            //filter the data;

            //
            let items = data_table.map_by_exp.filter(s => selectedExperiments.includes(s.ExperimentID));

            if(items.length!==0){
                data_table.participants = items;
            }

        }*/


        let query = getCurrentQuery(this.props.studyBucket.studies, this.props.studySettings);
        let query_id = (query) ? query.localId : "NA";

        return <ParticipantTable
            loadingParticipants = {this.props.loadingParticipants}
            updateParticipantsData={this.props.updateParticipantsData}
            selectParticipants = {this.selectParticipant}
            sampleList = {this.props.sampleList}
            experimentGeneMap = {this.props.sample_agg}
            participants = {data_table}
            query_id={query_id}
            selectedVariants = {this.state.selectedVariants}
            selectedGene={this.state.selectedGene}
            selectedGeneForVariantView={this.props.selectedGeneForVariantView}
            cnvAggregations={this.props.cnvAggregations}
        />



    }



    getTable(){

        let obj = this.getTableDataContent();


        let self = this;
        let { total, summary } =this.props;

        let type = (summary) ? "search_across" : "default";

        // Use filtered count when specific participants are selected so header matches table and participant table
        const displayCount = (self.state.selectedParticipants.length === 0) ? total : obj.data.length;

        // Determine the display text for number of genomics variants (same count as table)
        let snvDisplayText;
        if (total === -1) {
            snvDisplayText = "genomic variants not available";
        } else if (displayCount === 1) {
            snvDisplayText = "1 genomic variant";
        } else {
            snvDisplayText = displayCount + " genomic variants";
        }

        let tableEl =  <SNV_Table
            viewMode={self.state.viewMode}
            annotate_variants = {self.annotate_variants}
            getAllTaggedVariants = {self.props.getAllTaggedVariants}
            all_tagged_variants = {self.props.all_tagged_variants}
            passAnnotations={ self.props.passAnnotations}
            loading={self.props.loading}
            queryRunner={self.props.queryRunner}
            fetchData={ self.props.fetchData}
            total={displayCount}
            type={type}
            tagged_variants = {self.state.tagged_variants}
            data = {obj.data}
            participants = {this.state.selectedParticipants}
            selectedExperiments = {self.state.selectedExperiments}
            pageCount={Math.ceil((displayCount >= 0 ? displayCount : total) / 100)}
            pid_array = {(self.props.participants.participants!== undefined)
                ? self.props.participants.participants.map(s => s.report_id)
                : []}
        />


        let accordionEl = <Box p={1} style={{ float: "left", width: "100%" }}>
            <Accordion defaultExpanded={false}>
                <AccordionInfo
                    title="SNV and InDels"
                    total={snvDisplayText} 
                    type={type}
                    tooltipTitle= {<MappedText text="Note that the number of rows shown in the variants table can be higher than the number of genomic variants shown in the counter since one genomic variant can affect more than one gene." />}
                />
                <AccordionDetails>
                    {tableEl}
                </AccordionDetails>
            </Accordion>
        </Box>


        if(summary || this.props.cnv_data){
            return accordionEl;
        }
        else{
            return tableEl;
        }




    }

    setTableType(bool){

        this.setState({tableType:bool})  //true => variant table, false => Functional Mode

    }



    render(){
        const { t } = this.props; 
        let self  = this;

        let obj = this.getTableDataContent();
        let chrom_data = processVariantData(obj);
        let annotations = getAnalysisAnnotations(self.props.studySettings, self.props.studyBucket);

        let vertical ="bottom";
        let horizontal = "center";


        if(self.props.variants!== undefined)
        {
            return (
                <div className={'central-panel'}>
                    <Snackbar  open={this.state.snackMessage}
                               autoHideDuration={6000}
                               anchorOrigin={ {vertical, horizontal }}
                               onClose={this.handleSnackClose}>
                        <Alert onClose={this.handleSnackClose} severity="error">
                            {this.state.cnvSnackText || "CNV query: CNV data could not be loaded"}
                        </Alert>
                    </Snackbar>
                    {(self.props.summary)
                        ? null
                        : <ChromosomeChart initData = { chrom_data } data = { chrom_data } total={ self.props.total }/>}
                    <LeftPanel
                        classStyle={"leftSidePanel"}
                        summary = {self.props.summary}
                        sample_agg = {self.props.sample_agg}
                        queryRunner={self.props.queryRunner}
                        runSearchAcrossQuery={this.handleGeneSelected}
                        participants = {this.props.participants}
                        passExperiments = {self.selectedExperiments}
                        passGenes = {self.passGenes}
                        totalVariants={self.props.total}
                        cohortExperimentIds={self.props.cohortExperimentIds}
                        fullExperimentIds={self.props.fullExperimentIds}
                        onCnvQueryError={self.handleCnvQueryError}
                        onCnvSummaryReady={self.props.onCnvSummaryReady}
                        onCnvAggregationData={self.props.onCnvAggregationData}
                        onCnvExperimentsForParticipants={self.props.onCnvExperimentsForParticipants}
                    />
                    <div className="variant_table">
                        <AnalysesTabs
                            switchAnalysis = {self.props.switchAnalysis}
                            resetAll = {self.props.resetAll}
                            deleteButton={true}
                        />
                        <QueryTabs
                            switchQuery = {self.props.switchQuery}
                            total = {self.props.total}
                        />
                        <ToolBar_New
                            data = {obj.data}
                            setViewMode = {self.setViewMode}
                            setTableType = {self.setTableType}
                            annotations = {annotations}
                            annotate_variants = {self.annotate_variants}
                            tagged_variants = {self.props.all_tagged_variants}
                            getAllTaggedVariants = {self.props.getAllTaggedVariants}
                            passAnnotations={ self.props.passAnnotations}
                        />
                        {(self.props.summary)
                            ? this.getParticipantTable()
                            : null
                        }
                        {self.getTable()}
                        {(self.props.cnv_data)
                            ? this.getCNVTable()
                            : null
                        }
                    </div>


                </div>)
        }
        else if(self.props.requestStatus === STATIC_VARIABLES.UNAVAILABLE_SERVER){
            return <div className={'central-panel'}>
                <div className={"error_msg"}>
                    <CircularProgress />
                    The GPAP Genomics server is currently unavailable. We apologize for the the inconvenience. Please contact us at <a href="mailto:help@rd-connect.eu">help@rd-connect.eu</a> for more information.
                </div>
            </div>
        }
        else if(self.props.variants  === undefined ){
            return <div className={'central-panel'}>
                <div
                    className="error_msg"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh", // full height to center vertically
                        textAlign: "center",
                    }}
                >
                    <CircularProgress />
                    <p>Loading genomic variants</p>
                </div>
            </div>
        }

        else{
            return <div className={'central-panel'}>
                <div className={"error_msg"}>Ooops, the query returned an error;</div>
            </div>
        }

    }
}


function mapStateToProps (state) {
    if(state.variants!==undefined){

        return {
            token: state.authorization.token,
            selected_table_rows: state.selected_table_rows,
            studySettings: state.studySettings,
            studyBucket: state.studyBucket,
            patients: state.patients,
            genes_state : state.query.gene,
            freqInt_state: state.query.freqInt,
            clinvar_state: state.query.clinvarclasses,
            acmg_state: state.query.intervarclasses,
            // TODO: we need to get all the experiments in the analysis
            experiment: state.sample_list.samples.map(s => s.sample_id)
        }
    }
    else{
        return {snv: []}
    }
}

const mapDispatchToProps = (dispatch) => ({
    study_actions: bindActionCreators(StudyActions, dispatch),
    gpap_general_actions: bindActionCreators(GPAP_General_Actions, dispatch)
});



//export default Variant_Table


export default withTranslation('translation', { withRef: true })(connect(mapStateToProps, mapDispatchToProps)(Variant_Table));
